import { render, staticRenderFns } from "./SubLogo.vue?vue&type=template&id=07112362&"
import script from "./SubLogo.vue?vue&type=script&lang=js&"
export * from "./SubLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports